import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton } from '@/core/ui';
import { TypographyStyled } from './PageHeadTypography.styled';
const PageHeadTypography = ({ isLoading, ...typographyProps }) => {
    if (isLoading)
        return (_jsx(Skeleton, { width: 300, children: _jsx(TypographyStyled, { children: "SKELETON TEXT" }) }));
    return _jsx(TypographyStyled, { ...typographyProps });
};
export { PageHeadTypography };
